<template>
  <transition name="slide-down">
    <div v-if="visible" :class="toastClasses">
      <span v-if="iconClass" class="ui-toast-icon iconfont" :class="iconClass"></span>
      <span class="ui-toast-text">{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BaseToast',
  props: {
    visible: Boolean,
    message: { type: String, default: '' },
    type: { type: String, default: '' }
  },
  computed: {
    iconClass() {
      if (this.type === 'success') return 'icon-checkOK'
      if (this.type === 'error') return 'icon-error'
      if (this.type === 'info') return 'icon-notice'
      return ''
    },
    toastClasses() {
      const classes = [`ui-toast`]
      if (this.type) {
        classes.push(`ui-toast--${this.type}`)
      }
      return classes
    }
  }
}
</script>

<style>
.ui-toast {
  position: fixed;
  z-index: 11000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* min-width: 160px; */
  max-width: 90vw;
  padding: 14px 18px;
  border-radius: 10px;
  color: #ffffff;
  background: #777777;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2);
  word-break: break-word;
}

.ui-toast--info {
  background: #777777;
}

.ui-toast--success {
  background: #28a745;
}

.ui-toast--error {
  background: #d9534f;
}

.ui-toast-icon {
  font-size: 36px !important;
  line-height: 1;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.slide-down-enter {
  transform: translate(-50%, -60px);
  opacity: 0;
}

.slide-down-enter-to {
  transform: translate(-50%, -50%);
  opacity: 1;
}

.slide-down-leave {
  transform: translate(-50%, -50%);
  opacity: 1;
}

.slide-down-leave-to {
  transform: translate(-50%, -60px);
  opacity: 0;
}
</style>